<template>
  <div class="step__block-table">
    <div class="step__block-item step__block-item--head">
      <div class="step__block-item-text">
        <span>Number</span>
      </div>
      <div class="step__block-item-text">
        <span>Openings</span>
      </div>
      <div>
        <span>Square ft.</span>
      </div>
      <div>
        <span>Multiplier</span>
      </div>
      <div>
        <span>SUM</span>
      </div>
    </div>
    <div
      class="step__block-item"
      v-for="(item, index) in installationItemList"
      :key="`installation-item-${index}`"
    >
      <div class="step__block-item-text">
        <span>{{ item?.partitionName }}</span>
      </div>
      <div class="step__block-item-text">
        <span>{{ item?.title }}</span>
      </div>
      <div class="step__block-item-unit">
        <span>{{ item?.qty }}</span>
      </div>
      <div>
        <PriceValue :price="item.price" class="step__block-item-price" />
      </div>
      <div>
        <PriceValue :price="item.sum" class="step__block-item-price" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from "vue";
import { PriceValue } from "@/shared";

import { useInstallationStore } from "@/stores/new/installation.store";
import { useSpacesStore } from "@/stores/new/spaces.store";

const spacesStore = useSpacesStore();
const spaces = computed(() => spacesStore.spaces);

const newInstallationStore = useInstallationStore();
const installationItemList = computed(
  () => newInstallationStore.installationItemList,
);

watch(
  () => spaces.value,
  () => {
    newInstallationStore.createInstallationItemList();
  },
  {
    deep: true,
  },
);

onMounted(() => {
  newInstallationStore.createInstallationItemList();
});
</script>

<style scoped>
.step__block-table {
  padding: 15px 0;
  display: grid;
  row-gap: 5px;
}

.step__block-item {
  display: grid;
  grid-template-columns: 20% 25% repeat(3, 15%);
  column-gap: 20px;
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step__block-item-price.step__block-field-price {
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step__block-item-unit span {
  padding-right: 10px;
}

.step__block-item--head {
  margin-bottom: 20px;
}

.step__block-item div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.step__block-item div.step__block-item-text {
  align-items: flex-start;
}

.step__block-item div:last-child {
  align-items: flex-end;
}
</style>
